import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/ebook-bestia1.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/ebook-inside.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/ebook.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/for-who-img.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/krzysztof-bezbg.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/components/Nav.tsx");
